import { render, staticRenderFns } from "./InputColor.vue?vue&type=template&id=7f78a367&scoped=true&"
import script from "./InputColor.vue?vue&type=script&lang=ts&"
export * from "./InputColor.vue?vue&type=script&lang=ts&"
import style0 from "./InputColor.vue?vue&type=style&index=0&id=7f78a367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f78a367",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VColorPicker,VMenu})
